var map = {
  "./ru.json": [
    "434345",
    "530636"
  ],
  "./uk.json": [
    "698644",
    "399740"
  ],
  "./bg.json": [
    "804056",
    "805314"
  ],
  "./el.json": [
    "262501",
    "974700"
  ],
  "./en-pt.json": [
    "576647",
    "110587"
  ],
  "./sv.json": [
    "856607",
    "306771"
  ],
  "./zh-hans.json": [
    "864353",
    "814167"
  ],
  "./rw.json": [
    "320486",
    "338292"
  ],
  "./sr.json": [
    "567753",
    "955214"
  ],
  "./fr.json": [
    "637229",
    "451010"
  ],
  "./as.json": [
    "346866",
    "136801"
  ],
  "./kk.json": [
    "109104",
    "591042"
  ],
  "./nb.json": [
    "442046",
    "688947"
  ],
  "./uz.json": [
    "850161",
    "736113"
  ],
  "./ky.json": [
    "485562",
    "446420"
  ],
  "./pl.json": [
    "937907",
    "181001"
  ],
  "./ro.json": [
    "565548",
    "571820"
  ],
  "./ka.json": [
    "732294",
    "465092"
  ],
  "./hu.json": [
    "2796",
    "26176"
  ],
  "./de.json": [
    "506959",
    "630271"
  ],
  "./tr.json": [
    "525831",
    "514074"
  ],
  "./id.json": [
    "57564",
    "844499"
  ],
  "./lt.json": [
    "874129",
    "664938"
  ],
  "./lv.json": [
    "607929",
    "372415"
  ],
  "./es.json": [
    "800719",
    "135560"
  ],
  "./cs.json": [
    "838234",
    "749086"
  ],
  "./boxes.json": [
    "116599",
    "432915"
  ],
  "./sk.json": [
    "489055",
    "239329"
  ],
  "./nl.json": [
    "557699",
    "862537"
  ],
  "./accents.json": [
    "373793",
    "330635"
  ],
  "./pa.json": [
    "582127",
    "622660"
  ],
  "./pt.json": [
    "54276",
    "643606"
  ],
  "./extra.json": [
    "91105",
    "472871"
  ],
  "./it.json": [
    "415146",
    "171227"
  ],
  "./hi.json": [
    "438035",
    "286955"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 846422;
module.exports = webpackAsyncContext;
